// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_MY_INVESTED_ALGO_TOP = "GET_MY_INVESTED_ALGO_TOP";

export const API_MY_INVESTED_ALGO_GRAPH_SUCCESS = "API_MY_INVESTED_ALGO_GRAPH_SUCCESS";
export const API_MY_INVESTED_ALGO_GRAPH_ERROR = "API_MY_INVESTED_ALGO_GRAPH_ERROR";
export const GET_MY_INVESTED_ALGO_GRAPH = "MY_INVESTED_ALGO_GRAPH";
